const savedListDefaultState = {
    savedProducts: undefined,
}

export default (state = savedListDefaultState, action) => {

    switch (action.type) {
        case "SET_SAVED_LIST":
            // console.log(action.savedList)
            return { ...state, savedProducts: action.savedList }
        default:
            return state
    }
}
